// axios
import axios from 'axios';


//let baseURL =  "http://127.0.0.1:8000/api/v1";
const token = localStorage.getItem('token');



//let baseURL =  "http://api.mylaravelvue.local/api/v1";


let baseURL =  "https://www.api.gestionfitnesshero.com/api/v1";



//              http://api.mylaravelvue.local/api/v1/auth/login


export default axios.create({

    baseURL,
    headers: {
        'Content-Type': 'application/json',
        Authorization : `Bearer ${token}`
    }

})

